import React from 'react'
import styled from 'styled-components'
import colours from '../lib/colours'
import IconControl from './icon-control'

const ExpandoLink = styled.div` 
    color: ${colours.white};
    font-weight: bold;
    cursor: pointer;
    text-decoration: underline;
    :hover {
      color: ${colours.white};
      text-decoration: underline;
    }
`
const ContainerDiv = styled.div`
  margin-bottom: 10px;
  margin-top: 15px;
  text-color:white;
`

const PaddedContent = styled.div`
  margin-left: 18px;
  color:white;
  text-decoration:underline;
   
`

interface IProps {
  title: string
}

interface IState {
  expanded: boolean
}

class HamburgerControl extends React.Component<IProps, IState> {
  state: IState = {
    expanded: false
  }

  handleToggle = () => this.setState(prev => ({ expanded: !prev.expanded }))

  render() {
    const rotation = this.state.expanded ? -90 : 0
    const iconStyle = {
      transition: 'transform 0.3s',
      marginRight: 8
    }
    const title = this.state.expanded ? 'Close Region' : this.props.title
    return (
      <ContainerDiv>
        <div>   
          <ExpandoLink onClick={this.handleToggle}>
            
            <IconControl icon="bars" style={iconStyle} />
         {title}
          </ExpandoLink>
        </div>
        {this.state.expanded && (
          <PaddedContent onClick={this.handleToggle} >
            {this.props.children}
            </PaddedContent>
        )}
        
      </ContainerDiv>
    )
  }
}

export default HamburgerControl
